/**
 * 订单管理 交易订单
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>促销活动</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-date-picker
          v-model="date"
          type="date"
          placeholder="选择日期时间"
          default-time="12:00:00"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-select
          size="small"
          v-model="orderStatus"
          placeholder="请选择订单类型"
        >
          <el-option
            v-for="type in payway"
            :label="type.key"
            :value="type.value"
            :key="type.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button
          size="small"
          type="primary"
          icon="el-icon-search"
          @click="search"
          >搜索</el-button
        >
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table
      size="small"
      :data="activityList"
      highlight-current-row
      v-loading="loading"
      border
      element-loading-text="拼命加载中"
      style="width: 100%"
    >
      <el-table-column align="center" type="index" width="50" label="序号">
      </el-table-column>
      <el-table-column prop="activityName" label="名称" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="typeName" label="类型" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="periodTime" label="周期时间" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="periodTypeName" label="周期方式" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="periodDay" label="执行日期" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="content" label="活动门店" show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="activityTime"
        label="活动时间"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="updateTime"
        label="优惠对象"
        show-overflow-tooltip
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="updateTime"
        label="会员积分"
        show-overflow-tooltip
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="updateTime"
        label="活动简介"
        show-overflow-tooltip
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="updateTime"
        label="短信提醒"
        show-overflow-tooltip
        align="center"
      >
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="150">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)"
            >详情</el-button
          >
          <!-- <el-button size="mini" type="danger" @click="deleteUser(scope.$index, scope.row)">退款</el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination
      v-bind:child-msg="pageparm"
      @callFather="callFather"
    ></Pagination>
    <!-- 编辑界面 -->
    <el-dialog
      :title="title"
      :visible.sync="editFormVisible"
      width="50%"
      @click="closeDialog('editForm')"
    >
      <el-form label-width="120px" :model="editForm" ref="editForm">
        <el-row>
          <el-col :span="20">
            <el-form-item label="订单号">
              <el-input
                size="small"
                v-model="editForm.orderNum"
                auto-complete="off"
                placeholder="订单号"
                disabled
              ></el-input>
            </el-form-item>
            <el-form-item label="时间">
              <el-input
                size="small"
                v-model="editForm.createTime"
                auto-complete="off"
                placeholder="订单号"
                disabled
              ></el-input>
            </el-form-item>
            <el-form-item label="支付方式">
              <el-input
                size="small"
                v-model="editForm.payMethod"
                auto-complete="off"
                placeholder="请输入商户号"
                disabled
              ></el-input>
            </el-form-item>
            <el-form-item label="利润">
              <el-input
                size="small"
                v-model="editForm.subtract"
                auto-complete="off"
                placeholder="请输入微信子商户"
                disabled
              ></el-input>
            </el-form-item>
            <el-form-item label="支付金额">
              <el-input
                size="small"
                v-model="editForm.price"
                auto-complete="off"
                placeholder="请输入通知回调"
                disabled
              ></el-input>
            </el-form-item>
            <el-form-item label="会员优惠">
              <el-input
                size="small"
                v-model="editForm.vipYouHuiPrice"
                auto-complete="off"
                placeholder="请输入加密类型"
                disabled
              ></el-input>
            </el-form-item>
            <el-form-item label="活动优惠">
              <el-input
                size="small"
                v-model="editForm.activityYouHuiPrice"
                auto-complete="off"
                placeholder="请输入商户签名密钥"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="购买商品">
          <el-input
            size="small"
            v-model="editForm.newContent"
            auto-complete="off"
            placeholder="购买的商品"
            disabled
            style="white-space: pre-line"
          ></el-input>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { OrderList, OrderRefund, OrderDelete } from "../../api/payMG";
import Pagination from "../../components/Pagination";

import {
  getOrder,
  getSaleActivity,
  getOverdueSaleActivity,
  getStoreList,//获取门店列表
} from "@/api/api.js";
export default {
  data() {
    return {
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: "预览",
      date: "",
      year: "",
      month: "",
      day: "",
      orderStatus: "", //订单类型
      payway: [
        { key: "全部订单", value: 0 },
        { key: "已完成订单", value: 1 },
        { key: "已取消订单", value: 2 },
        { key: "已退款订单", value: 3 },
      ],
      activityList: "", //活动列表
      overActivityList: "", //已过期活动列表
      editForm: {
        id: "",
        name: "",
        payType: 1,
        partner: "",
        subMchId: "",
        appid: "",
        notifyUrl: "",
        signType: "",
        partnerKey: "",
        sellerUserId: "",
        certPath: "",
        certPassword: "",
        rsaKey: "",
        token: localStorage.getItem("logintoken"),
      },
      formInline: {
        page: 1,
        limit: 10,
        machineNo: "",
        orderNo: "",
        transId: "",
        payType: 0,
        orderStatus: 0,
        token: localStorage.getItem("logintoken"),
      },
      // 删除部门
      seletedata: {
        ids: "",
        token: localStorage.getItem("logintoken"),
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10,
      },
    };
  },
  // 注册组件
  components: {
    Pagination,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    // this.getdata(this.formInline);
    this.getStoreList();
    this.getData();

  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取活动数据
    getData() {
      this.loading = true;
      //转化日期的格式
    //   const selectedDate = new Date(this.date);
    //   this.year = selectedDate.getFullYear();
    //   this.month = selectedDate.getMonth() + 1; // 月份从0开始，所以要加1
    //   this.day = selectedDate.getDate();
      //   获取正在进行中的活动数据
      getSaleActivity({
        storeId: localStorage.getItem("storeId"),
      }).then((res) => {
        //改变数组里元素的某个属性
        res.data.data.forEach((item) => {
          // 把2022-10-21换成2022.10.21格式，然后拼接上另一个时间，构成一个时间段
          item.activityTime =
            item.startTime.replace(/-/g, ".") +
            "-" +
            item.endTime.replace(/-/g, ".");
            if(item.periodEndTime&&item.periodStartTime){
                item.periodTime = item.periodStartTime + "-" + item.periodEndTime;
            }

          switch (item.periodType) {
            case "day":
              item.periodTypeName = "每天执行";
              break;
            case "week":
              item.periodTypeName = "每周执行";
              break;
            case "month":
              item.periodTypeName = "每月执行";
              break;
          }
          //根据type的类型，判断是什么类型的活动，赋予一个typeName字段，用switch方法
          switch (item.type) {
            case "specialActivity":
              item.typeName = "特价活动";
              break;
            case "offerFoldCoupons":
              item.typeName = "折扣券";
              break;
            case "vip_active":
              item.typeName = "会员活动";
              break;
            case "discount":
              item.typeName = "折扣活动";
              break;
            case "offerCoinCoupons":
              item.typeName = "兑换券";
              break;
            case "offerMinusCoupons":
              item.typeName = "满减券";
              break;
            case "FullMinusActivity":
              item.typeName = "满N件减/送";
              break;
            case "fullFoldActivity":
              item.typeName = "满N元折/送";
              break;
            case "BuyActivity":
              item.typeName = "第n件促销";
              break;
            case "":
              item.typeName = "满免折赠";
              break;
            case "":
              item.typeName = "满免折送赠";
              break;
          }
          //根据
        });
        this.activityList = res.data.data;
        this.loading = false;
        this.pageparm.currentPage = this.formInline.page;
        this.pageparm.pageSize = this.formInline.limit;
        this.pageparm.total = res.data.total;
      });
    },
    //获取门店列表
    getStoreList() {
      getStoreList().then((res) => {
        this.storeList = res.data.data;
      });
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage;
      this.pageparm.currentPage = parm.currentPage;
      this.formInline.limit = parm.pageSize;
      this.pageparm.pageSize = parm.pageSize;
      // this.getdata(this.formInline)
      this.getData();
    },
    // 搜索事件
    search() {
      // this.getdata(this.formInline)
      this.getData();
    },
    //显示编辑界面
    handleEdit: function (index, row) {
      this.editFormVisible = true;
      this.editForm = row;
      console.log(index, row, "333333");
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate((valid) => {
        if (valid) {
          ConfigSave(this.editForm)
            .then((res) => {
              this.editFormVisible = false;
              this.loading = false;
              if (res.success) {
                this.getdata(this.formInline);
                this.$message({
                  type: "success",
                  message: "公司保存成功！",
                });
              } else {
                this.$message({
                  type: "info",
                  message: res.msg,
                });
              }
            })
            .catch((err) => {
              this.editFormVisible = false;
              this.loading = false;
              this.$message.error("支付配置信息保存失败，请稍后再试！");
            });
        } else {
          return false;
        }
      });
    },
    // 删除公司
    deleteUser(index, row) {
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          ConfigDelete(row.deptId)
            .then((res) => {
              if (res.success) {
                this.$message({
                  type: "success",
                  message: "公司已删除!",
                });
                this.getdata(this.formInline);
              } else {
                this.$message({
                  type: "info",
                  message: res.msg,
                });
              }
            })
            .catch((err) => {
              this.loading = false;
              this.$message.error("支付配置信息删除失败，请稍后再试！");
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      this.editFormVisible = false;
      this.$refs[formName].resetFields();
    },
  },
};
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>







// WEBPACK FOOTER //
// src/views/system/saleActivity.vue